import CtaSection from 'components/home/CtaSection';
import FeatureRow from 'components/home/FeatureSection/FeatureRow';
import Layout from 'components/home/Layout';
import SEO from 'components/home/SEO';
import { NextPage } from 'next';
import { BiTransfer } from 'react-icons/bi';
import { FaJenkins } from 'react-icons/fa';
import { TbGitPullRequestClosed } from 'react-icons/tb';

const features = [
  {
    title: 'Run Tests',
    description:
      'Your performance tests can run on any CI/CD environment, eg. GitHub Actions, CircleCI, and Jenkins. Latency Lingo allows you to maintain your existing CI/CD workflows.',
    icon: <FaJenkins className="w-8 h-8 sm:w-14 sm:h-14" />,
  },
  {
    title: 'Publish Results',
    description:
      'The Latency Lingo CLI is used to publish results from your CI/CD environment. You only need two commands to install the CLI and publish your test results file to Latency Lingo.',
    icon: <BiTransfer className="w-8 h-8 sm:w-14 sm:h-14" />,
  },
  {
    title: 'Define Thresholds',
    description:
      'Catch performance regressions in your build pipeline by creating Latency Lingo thresholds. Thresholds apply to all runs in a scenario and build status can be accessed through our APIs.',
    icon: <TbGitPullRequestClosed className="w-8 h-8 sm:w-14 sm:h-14" />,
    last: true,
  },
];

const AutomatedTestingPage: NextPage = () => {
  return (
    <>
      <SEO title="Automated Testing" />
      <Layout>
        <section className="text-gray-700 body-font bg-gray-50">
          <div className="container flex flex-col items-center px-5 pt-12 pb-6 mx-auto md:flex-row">
            <div className="flex flex-col items-center text-center mb-6 md:mb-0 md:w-1/2 lg:pr-24 md:pr-16 md:items-start md:text-left">
              <h1 className="mb-4 text-3xl font-bold text-san-juan-blue-500 title-font sm:text-4xl">
                Automate your testing with Latency Lingo
              </h1>
              <p className="mb-8 leading-relaxed">
                Define pass/fail conditions for your tests. Integrate with your
                CI/CD pipeline to enforce performance budgets.
              </p>
              <div className="flex justify-center">
                <a
                  href="https://docs.latencylingo.com/docs/intro"
                  target="_blank"
                  rel="noreferrer"
                >
                  <button className="px-8 py-4 text-lg font-medium text-summer-green-700 bg-summer-green-100 shadow border border-summer-green-300 rounded focus:outline-none hover:bg-summer-green-200">
                    Learn more
                  </button>
                </a>
              </div>
            </div>
            <div className="w-5/6 mb-10 md:w-1/2 md:mb-0 border border-gray-200">
              <img
                className="object-cover object-center rounded"
                alt="hero"
                src="/img/docs/dashboard-scenarios.png"
                loading="lazy"
              />
              <img
                className="object-cover object-center rounded"
                alt="hero"
                src="/img/docs/dashboard-recent-runs.png"
                loading="lazy"
              />
            </div>
          </div>
        </section>
        <section className="text-gray-700 pt-6 body-font md:w-2/3 mx-auto">
          <div className="flex flex-wrap px-4">
            {features.map((feature, i) => (
              <FeatureRow key={i} title="" {...feature} />
            ))}
          </div>
        </section>
        <CtaSection learnMoreLink="https://docs.latencylingo.com/docs/intro" />
      </Layout>
    </>
  );
};

export default AutomatedTestingPage;
